import { render, staticRenderFns } from "./AppTemplate.vue?vue&type=template&id=71bd3d6a&scoped=true"
import script from "./AppTemplate.vue?vue&type=script&lang=js"
export * from "./AppTemplate.vue?vue&type=script&lang=js"
import style0 from "./AppTemplate.vue?vue&type=style&index=0&id=71bd3d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd3d6a",
  null
  
)

export default component.exports